import { fetchSCS } from '@cube/utils/lib/scs-api';

export function fetchSpecialTitle(site, origin) {
	return fetchSCS(`/feeds/id/gen4_sc_special_title/`, site, origin);
}
